import React from 'react'

function Test() {
    return (
        <>

            <div className='max-w-5xl mx-auto h-screen bg-red-400'>
                <div className='text-center w-full bg-gray-500 text-red-500 hover:translate-y-72 transition duration-500 ease-out'>
                    asdasdasd
                </div>
            </div>
        </>

    )
}

export default Test